import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useUserForgotPasswordMutation } from '../slices/usersApiSlice';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import Message from '../components/Message';


export default function UserForgotPasswordScreen() {
  const [primaryEmail, setPrimaryEmail] = useState('');

  const [forgotPassword, { isLoading, error }] = useUserForgotPasswordMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword({ primaryEmail }).unwrap();
      toast.success("Success: Check your e-mail for reset instructions from JDiskMark");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const renderError = (error) => {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (error.data?.message) return error.data.message;
    if (error.error) return error.error;
    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  };

  return (
    <FormContainer>
      <h1>Forgot Password</h1>
      {isLoading && <Loader />}
      { error && <Message variant='danger'>{renderError(error)}</Message> }
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="email" className="my-3">
          <Form.Label>E-Mail Address:</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your primary e-mail address"
            value={primaryEmail}
            onChange={(e) => setPrimaryEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Button type="submit" variant="primary" className="my-2">
          Request Password Reset
        </Button>
        <div className="mt-3">
          <Link to="/sign_in">Return to Sign In</Link>
        </div>
      </Form>
    </FormContainer>
  );
};